<template>
  <v-app>
    <v-dialog
      v-model="restore.dialog"
      persistent
      scrollable
      max-width="600">
      <v-card>
        <v-card-title class="text-h5 d-flex align-center">
          Восстановить пароль
          <v-spacer />
          <v-btn
            icon
            variant="text"
            color="secondary"
            @click="restore.dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="restore.email"
            label="Введите ваш e-mail"
            prepend-icon="mdi-email-outline"
            variant="underlined"
            hide-details />
        </v-card-text>

        <v-card-actions class="flex-wrap">
          <v-spacer />
          <v-btn
            color="primary"
            variant="text"
            :loading="restore.loading"
            :disabled="restore.loading"
            @click="execRestorePwd">
            <v-icon start>mdi-backup-restore</v-icon>
            Отправить ссылку
          </v-btn>
          <v-btn
            color="secondary"
            variant="text"
            @click="restore.dialog = false">
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="wait_fa"
      persistent
      max-width="600">
      <v-card>
        <v-card-title class="text-h5 justify-center"> Двухфакторная авторизация </v-card-title>

        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            :size="80"
            :width="8"
            color="primary"
            class="my-2" />
          <div class="text-body-1 mt-2">Подтвердите вход вторым фактором</div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-main class="login-form-bg">
      <v-container
        fluid
        class="fill-height">
        <v-row
          align="center"
          justify="center">
          <v-col
            cols="12"
            sm="8"
            md="8"
            lg="6">
            <v-card
              elevation="4"
              class="login-form-card">
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                    class="d-flex align-center">
                    <v-img
                      :src="logo"
                      contain />
                  </v-col>

                  <v-col
                    cols="12"
                    md="8">
                    <div class="text-right">
                      <v-chip
                        size="x-small"
                        label
                        variant="outlined">
                        {{ version }}
                      </v-chip>
                    </div>

                    <!-- Desktop -->
                    <h1 class="mb-2 text-grey-darken-3 d-none d-md-flex">
                      {{ title }}
                    </h1>

                    <!-- Mobile -->
                    <h3 class="mb-2 text-grey-darken-3 d-flex d-md-none">
                      {{ title }}
                    </h3>

                    <v-text-field
                      v-model="login"
                      label="Имя пользователя"
                      prepend-icon="mdi-account-outline"
                      variant="underlined"
                      :error="!!errorText"
                      :error-messages="errorText ? [errorText] : []"
                      @keyup.enter="authenticate" />

                    <v-text-field
                      v-model="password"
                      label="Пароль"
                      prepend-icon="mdi-lock-outline"
                      variant="underlined"
                      :append-inner-icon="showpwd ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showpwd ? 'text' : 'password'"
                      :error="!!errorText"
                      :error-messages="errorText ? [errorText] : []"
                      @click:append-inner="showpwd = !showpwd"
                      @keyup.enter="authenticate" />
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <div class="d-flex flex-column align-center w-100">
                  <v-btn
                    color="primary"
                    block
                    @click="authenticate"
                    variant="elevated">
                    <v-icon start>mdi-login-variant</v-icon>
                    Вход
                  </v-btn>

                  <div
                    v-if="showRestorePassword"
                    class="mt-3">
                    <a
                      href="#"
                      class="text-uppercase"
                      @click.prevent="restorePwdDialog">
                      Восстановить пароль
                    </a>
                  </div>
                </div>
              </v-card-actions>

              <div v-if="accounts.length">
                <hr class="my-3" />
                <v-btn
                  v-for="account in accounts"
                  :key="account.id"
                  block
                  variant="outlined"
                  color="primary"
                  class="mb-1"
                  @click="switchAccount(account)">
                  <v-avatar
                    size="30"
                    class="mr-2">
                    <v-img
                      :src="account.avatar_link"
                      contain />
                  </v-avatar>
                  {{ account.name_short }}
                </v-btn>
              </div>
            </v-card>

            <div v-if="showAlerts">
              <v-alert
                class="mt-2 text-grey-darken-2 text-justify"
                color="yellow-lighten-4"
                elevation="4">
                <template #prepend>
                  <v-icon
                    size="x-large"
                    class="mr-2 d-none d-sm-flex"
                    color="grey-darken-2">
                    mdi-information-outline
                  </v-icon>
                </template>
                Выполняя вход на Портал Пермского ГАТУ, я даю своё согласие ФГБОУ ВО Пермскому ГАТУ на обработку моих персональных данных, в соответствии с Федеральным законом от 27.07.2006 года №152-ФЗ «О персональных данных». Обработка
                осуществляется в соответствии с
                <a href="https://pgatu.ru/generalinfo/document/02polozhenie_po_obrabotke_zaschite_pd.pdf">Положением об обработке и защите персональных данных</a>.
              </v-alert>

              <v-alert
                class="mt-2 text-grey-darken-3 text-justify"
                color="blue-lighten-5"
                elevation="4">
                <template #prepend>
                  <v-icon
                    size="x-large"
                    class="mr-2 d-none d-sm-flex"
                    color="grey-darken-2">
                    mdi-account-question-outline
                  </v-icon>
                </template>
                При возникновении проблем со входом:
                <a href="mailto:ui@pgatu.ru">ui@pgatu.ru</a>
              </v-alert>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { moduleFnUrl } from "./../index.ts";

const authModuleFnUrl = (modfn: string) => `/module/authservice/${modfn}`;
let checkFactorInterval: any = null;

export default {
  props: {},
  data() {
    return {
      login: "",
      password: "",
      showpwd: false, // Показываем ли пароль в поле для ввода
      title: "", // Наименование (приходит с сервера на mounted)
      logo: "/img/logo.svg", // Логотип (приходит с сервера на mounted)
      version: "", // Версия (приходит с сервера на mounted)
      auth_services: [] as any[], // Сервисы авторизации (приходит с сервера на mounted)
      errorText: "",
      accounts: [] as any[],
      restore: {
        dialog: false,
        email: "",
        loading: false,
      },
      wait_fa: false,
      fatoken: "",
      variant: "",
      twofactor_token: "",
      fa_deny: false,
    };
  },
  computed: {
    showRestorePassword() {
      return ["main", "dev"].includes(this.variant);
    },
    showAlerts() {
      return ["main", "dev"].includes(this.variant);
    },
  },
  methods: {
    async switchAccount(account: any) {
      await Client.request.post({
        url: `/switchaccount`,
        data: {
          person_id: account.id,
        },
      });
      Client.request.redirect("/");
    },
    async execRestorePwd() {
      try {
        this.restore.loading = true;
        const result = await Client.request.post({
          url: `/restorepwd`,
          data: {
            email: this.restore.email,
          },
        });
        this.restore.loading = false;
        if (result == "OK") {
          Client.msg.success("Сообщение отправлено, проверьте почту. Срок действия ссылки на смену пароля - 10 минут.");
          this.restore.dialog = false;
        }
      } catch (err) {
        this.restore.loading = false;
        console.error(err);
      }
    },
    restorePwdDialog() {
      this.restore.dialog = true;
      this.restore.email = "";
    },
    clearCheckFactorInterval() {
      if (checkFactorInterval != null) {
        clearInterval(checkFactorInterval);
        checkFactorInterval = null;
      }
      ``;
    },
    async authenticate() {
      try {
        this.twofactor_token = "";
        this.wait_fa = false;
        this.fa_deny = false;
        this.errorText = "";
        const data = await Client.request.post({
          url: `/authenticate`,
          data: {
            login: this.login,
            password: this.password,
          },
          noErrorMessage: true,
        });
        this.login = "";
        this.password = "";

        if (data.indexOf("2FA_WAIT") != -1) {
          this.fatoken = data.split("2FA_WAIT")[1];
          this.wait_fa = true;
          this.clearCheckFactorInterval();
          checkFactorInterval = setInterval(async () => {
            const faresult = await Client.request.post({
              url: `/2fares`,
              data: {
                fatoken: this.fatoken,
              },
            });
            if (faresult == "grant") {
              this.clearCheckFactorInterval();
              Client.request.redirect("/");
              return;
            }
            if (faresult == "deny") {
              this.wait_fa = false;
              this.clearCheckFactorInterval();
              Client.msg.errorHead("Вход запрещен!", "");
            }
          }, 1000);
        } else {
          Client.request.redirect("/");
        }
      } catch (err: any) {
        this.errorText = err.message;
      }
    },
    async VKHandler() {
      // const vkidparams = await Client.request.post({
      //   url: authModuleFnUrl(`vkidparams`),
      // });
      // VKID.Config.init(vkidparams);
      // VKID.Auth.login();
    },
  },
  events: {},
  beforeMount() {},
  async mounted() {
    /** @type {Common.ConfigParamMain} */
    const { main, auth_services, accounts, variant } = await Client.request.post({
      url: moduleFnUrl("applogindata"),
    });
    this.title = main.title;
    this.version = main.version;
    this.variant = variant;
    if (main.logo != "") this.logo = main.logo;
    this.auth_services = auth_services;
    // for (const service of this.auth_services) {
    //   service.handler = (() => {});
    //   if (service.name == 'vk') {
    //     service.enabled = true;
    //     service.handler = this.VKHandler;
    //   }
    // }
    if (accounts != null) {
      this.accounts = accounts;
    }
  },
};
</script>
